import { Card, SectionMessage } from "@certn/cascadia-react";

import { DocumentsTabContainer } from "../DocumentsTabContainer";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

interface DocumentsTabProps {
  caseId?: string;
}

export function DocumentsTab({ caseId }: DocumentsTabProps) {
  const { t } = useTranslation();
  const routeParams = useParams();
  const caseShortId = caseId || routeParams.caseId;

  if (!caseShortId) {
    return (
      <Card testID="documents-tab" type="large" responsive>
        <SectionMessage
          type="danger"
          sectionTitle={t(
            "An error occurred while loading the documents linked to this case. Please try again later."
          )}
          icon="error"
        />
      </Card>
    );
  }

  return (
    <Card testID="documents-tab" type="large" responsive>
      <DocumentsTabContainer caseId={caseShortId} />
    </Card>
  );
}
